import React, { useState, useEffect, useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Download, FileText, Inbox, ArrowRight } from 'react-feather';
import DataTable from 'react-data-table-component';
import axios from 'axios';

import { OrgnaziationContext } from '../../../../Home';
import SpinnerLoader from '../../../../V2/Common/LoadingAnimation/SpinnerLoader.component';

const tableStyles = {
  headRow: { style: { borderBottom: '1px solid #e9ecef', minHeight: '40px' } },
  headCells: {
    style: {
      fontSize: '11px',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.04em',
      color: '#6c757d',
    },
  },
  rows: { style: { minHeight: '44px', fontSize: '13px' } },
  cells: { style: { paddingTop: '6px', paddingBottom: '6px' } },
};

export default function UploadedFilesCard() {
  const { orgName } = useContext(OrgnaziationContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (orgName) {
      setLoading(true);
      axios
        .get(`/api/v1/organizations/${orgName}/dashboard/fetch_last_ten_uploaded_files_from_es?page_type=client&controller_name=dashboard`)
        .then((res) => {
          setData(res?.data?.last_ten_uploaded_files || []);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
  }, [orgName]);

  const columns = [
    { name: 'Site', selector: 'site_name', sortable: true, grow: 2 },
    { name: 'Records', selector: 'no_of_records', sortable: true, right: true, width: '100px' },
    { name: 'Uploaded', selector: 'upload_time', sortable: true, width: '170px' },
    {
      name: '',
      width: '70px',
      right: true,
      cell: (row) => (
        <a
          href={row.download_url}
          target='_blank'
          rel='noreferrer'
          className='btn btn-sm btn-outline-primary d-inline-flex align-items-center'
          style={{ padding: '4px 8px' }}
          title='Download file'
        >
          <Download size={14} />
        </a>
      ),
    },
  ];

  return (
    <Card className='shadow-sm border-0 h-100'>
      <CardBody style={{ padding: 24 }}>
        <div className='d-flex align-items-start justify-content-between mb-3'>
          <div>
            <h6 className='fw-semibold mb-1 text-dark d-inline-flex align-items-center' style={{ fontSize: 16 }}>
              <FileText size={16} className='me-2' style={{ color: '#0d6efd' }} />
              Last 10 uploaded files
            </h6>
            <p className='text-muted mb-0' style={{ fontSize: 13 }}>
              Most recent crawl outputs delivered to your account.
            </p>
          </div>
        </div>

        <SpinnerLoader loading={loading}>
          {data.length > 0 ? (
            <DataTable columns={columns} data={data} noHeader responsive customStyles={tableStyles} />
          ) : (
            <div className='d-flex flex-column align-items-center justify-content-center text-muted py-5'>
              <Inbox size={28} className='mb-2 opacity-50' />
              <p className='mb-0' style={{ fontSize: 13 }}>
                No files uploaded yet.
              </p>
            </div>
          )}
        </SpinnerLoader>

        {orgName && (
          <a
            href={`/organizations/${orgName}/api_details`}
            className='d-inline-flex align-items-center text-decoration-none mt-3'
            style={{ fontSize: 13, color: '#0d6efd', fontWeight: 500 }}
          >
            View instructions for accessing all files
            <ArrowRight size={14} className='ms-1' />
          </a>
        )}
      </CardBody>
    </Card>
  );
}
